var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAddImgActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_598_13583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5552 11.9997H8.44412M22.6663 11.9997C22.6663 13.4004 22.3904 14.7875 21.8544 16.0816C21.3183 17.3758 20.5326 18.5517 19.5421 19.5421C18.5517 20.5326 17.3758 21.3183 16.0816 21.8544C14.7875 22.3904 13.4004 22.6663 11.9997 22.6663C10.5989 22.6663 9.21186 22.3904 7.91772 21.8544C6.62358 21.3183 5.44769 20.5326 4.4572 19.5421C3.46671 18.5517 2.68101 17.3758 2.14496 16.0816C1.60891 14.7875 1.33301 13.4004 1.33301 11.9997C1.33301 9.1707 2.45681 6.45759 4.4572 4.4572C6.45759 2.45681 9.1707 1.33301 11.9997 1.33301C14.8287 1.33301 17.5418 2.45681 19.5421 4.4572C21.5425 6.45759 22.6663 9.1707 22.6663 11.9997Z",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8L12 16",
    stroke: "#0076FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_598_13583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.04,
    height: 24,
    fill: "#0076FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddImgActive);
export default __webpack_public_path__ + "static/media/ico-add-img-active.6d14537094b4133086b6317938811166.svg";
export { ForwardRef as ReactComponent };